import CustomerLogo from '../CustomerLogo';

const LogoWorkiva = () => {
  return (
    <CustomerLogo
      fill="currentColor"
      role="img"
      viewBox="0 0 144 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Workiva logo</title>
      <path
        d="M32.4194 2.5L23.754 28.9067L20.1025 16.6478H14.2373L20.9823 35.99H27.2259L39.013 2.5H32.4194Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M10.0844 28.9067L5.94088 16.6478H0L6.74498 35.99H13.5751L16.3563 27.7261L13.3481 19.1222L10.0844 28.9067Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M81.3938 25.3745L90.9011 16.6478H82.9831L76.8814 22.3711V7.92114H71.2811V35.99H76.8814V28.255L84.4494 35.99H92.0268L81.3938 25.3745Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M69.3228 22.4184C69.3228 22.4184 68.566 21.8989 66.6362 21.8989C65.2172 21.8989 64.0063 22.73 63.5333 23.3628C63.0603 23.9861 62.5495 25.2422 62.5495 27.405V35.9995H56.6748V16.6478H62.5495L62.5116 19.3961H62.5873C63.6847 17.2806 65.3023 16.27 67.3835 16.27C68.6796 16.27 69.3228 16.6572 69.3228 16.6572V22.4184Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M44.0836 36.5C37.9251 36.5 33.2613 32.675 33.2613 26.4039C33.2613 20.1328 37.9251 16.27 44.0836 16.27C50.242 16.27 54.8679 20.1328 54.8679 26.4039C54.8679 32.675 50.242 36.5 44.0836 36.5ZM44.0836 21.2378C41.2834 21.2378 39.6563 23.41 39.6563 26.2811C39.6563 29.1617 41.2739 31.3245 44.0836 31.3245C46.8459 31.3245 48.5108 29.1522 48.5108 26.2811C48.5108 23.41 46.8459 21.2378 44.0836 21.2378Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M141.294 35.9994H135.249L135.127 34.0161C134.294 34.8472 132.714 36.5 129.555 36.5C126.121 36.5 122.488 34.6489 122.488 30.3139C122.488 25.9789 126.48 24.515 130.065 24.3639L134.966 24.1655V23.7311C134.966 21.6816 133.509 20.6144 130.974 20.6144C128.486 20.6144 125.998 21.7194 125.014 22.3522L123.358 18.2533C125.014 17.4222 128.06 16.2794 131.693 16.2794C135.325 16.2794 137.416 17.1105 138.958 18.5272C140.462 19.9439 141.285 21.8422 141.285 25.11V35.9994H141.294ZM135.022 27.5089L131.901 27.7072C129.961 27.7828 128.817 28.6139 128.817 30.0683C128.817 31.57 130.037 32.4766 131.778 32.4766C133.471 32.4766 134.625 31.3716 135.013 30.7011V27.5089H135.022Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M122.497 16.6478L114.513 35.9994H108.62L100.683 16.6478H107.248L111.647 28.8878L116.008 16.6478H122.497Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M99.0083 35.99H92.7174V16.6478H99.0083V35.99Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
      <path
        d="M92.7174 15.0139V7.92114H100.427L92.7174 15.0139Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </CustomerLogo>
  );
};

export default LogoWorkiva;
